(function(){"use strict";if(window.__gdFullCartKlaviyoInstalled)return;window.__gdFullCartKlaviyoInstalled=!0;function rootPath(){return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||"/"}function prop(item,key){return item&&item.properties&&item.properties[key]!=null?String(item.properties[key]):""}function imageUrl(value){if(!value)return"";try{return new URL(String(value),window.location.origin).href}catch{return""}}function isTrue(value){return value===!0||value==="true"||value==="1"}async function trackFullCart(){var response=await fetch(rootPath()+"cart.js",{credentials:"same-origin",cache:"no-store"});if(response.ok){var cart=await response.json(),cartItems=Array.isArray(cart.items)?cart.items:[],bundleIds=new Set(cartItems.map(function(item){var id=prop(item,"__bundle_id");return id&&isTrue(prop(item,"_kit"))?id:""}).filter(Boolean)),items=cartItems.filter(function(item){var price=Number(item.final_price!=null?item.final_price:item.price)||0;if(price>0)return!0;var bundleId=prop(item,"__bundle_id");return isTrue(prop(item,"_free_gift"))||isTrue(prop(item,"_gd_gift"))||isTrue(prop(item,"_addon"))&&bundleId&&bundleIds.has(bundleId)}).map(function(item){var unitPrice=Number(item.final_price!=null?item.final_price:item.price)||0,linePrice=Number(item.final_line_price!=null?item.final_line_price:unitPrice*(Number(item.quantity)||0))||0,bundleId=prop(item,"__bundle_id");return{ProductID:item.product_id!=null?String(item.product_id):"",VariantID:item.variant_id!=null?String(item.variant_id):"",SKU:item.sku||"",Name:item.product_title||item.title||"",VariantTitle:item.variant_title||"",Quantity:Number(item.quantity)||0,Price:Number((unitPrice/100).toFixed(2)),LineTotal:Number((linePrice/100).toFixed(2)),ImageURL:imageUrl(item.image),URL:imageUrl(item.url),IsBundleChild:isTrue(prop(item,"_addon")),IsFreeGift:isTrue(prop(item,"_free_gift"))||isTrue(prop(item,"_gd_gift")),BundleID:bundleId}});window._learnq&&typeof window._learnq.push=="function"&&window._learnq.push(["track","Added to Cart - Full Cart",{$value:Number(((Number(cart.total_price)||0)/100).toFixed(2)),Currency:cart.currency||"",CartItemCount:Number(cart.item_count)||0,Items:items}])}}window.GlamrDipFullCartKlaviyo=trackFullCart;var timer;document.addEventListener("product-added-to-cart",function(){clearTimeout(timer),timer=setTimeout(function(){trackFullCart().catch(function(error){console.warn("Klaviyo full-cart tracking failed",error)})},300)},!0)})();
/**
 * GLAMRDiP global AJAX add-to-cart intercept.
 *
 * Problem: Dawn's product-form.js AJAXes to /cart/add.js but then tries to render into
 *   <cart-notification> or <cart-drawer> custom elements. We don't ship those custom
 *   elements (our drawer is a plain <aside data-gd-cart-drawer>), so Dawn falls through to
 *   `window.location = routes.cart_url` — the /cart redirect the user is seeing.
 *
 * Fix: document-level capture-phase listener that matches every form whose action points
 * to /cart/add (with or without .js suffix, absolute or root-relative). preventDefault +
 * stopImmediatePropagation so Dawn's form-level bubble-phase handler never fires. We POST
 * the FormData ourselves, then dispatch the events the drawer already listens for:
 *   - product-added-to-cart  → drawer.refresh() + open()
 *   - gd:cart-open           → drawer.open()
 *
 * Line-item properties ride the FormData automatically (hidden inputs prefixed with
 * `properties[...]`). No special handling needed for kit/IG bundles from form-based flows.
 * The builder sections (kit-builder.js / instant-gels-builder.js) bypass forms entirely —
 * they build items[] arrays and fetch /cart/add.js themselves, so this interceptor never
 * touches them.
 *
 * No-JS fallback: forms still have action="/cart/add" so the browser's default submit works
 * identically to today.
 */
(() => {
  'use strict';

  // Match any of: /cart/add, /cart/add?, /cart/add.js, /cart/add.js? — root-relative or absolute
  const ACTION_RE = /\/cart\/add(?:\.js)?(?:\?.*)?$/;

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!ACTION_RE.test(action)) return;

      e.preventDefault();
      // Stop Dawn's product-form bubble-phase submit handler from running (it would redirect
      // to /cart on success because our theme has no <cart-notification> / <cart-drawer>
      // custom element).
      e.stopImmediatePropagation();

      // Joel 2026-05-01: Layer 1 defence — block direct cart-add on
      // products tagged `bundle-component-only`. These $0 SKUs exist
      // ONLY as bundle children and must never be addable as standalone
      // line items (revenue-loss path; see CLAUDE.md "Bundle component
      // safety system" rule).
      // Each ATC button sets `data-bundle-component-only="true"` via
      // Liquid when the product's tag matches. Server-level enforcement
      // (Shopify Cart Transform / webhook reactive removal) is the
      // primary defence; this JS layer prevents the most common
      // accidental path via the user's normal click.
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn?.dataset.bundleComponentOnly === 'true') {
        e.stopImmediatePropagation();
        const errorEl = form.querySelector('[data-gd-cart-form-error]');
        if (errorEl) {
          errorEl.innerHTML = 'This shade is only available as part of a Salon Kit bundle. <a href="/products/new-dip-perfect-complete-kit">Build your kit →</a>';
          errorEl.hidden = false;
        } else {
          alert('This shade is only available as part of a Salon Kit bundle. Build your kit on the Salon Kit page.');
        }
        return;
      }

      handleAdd(form);
    },
    true // capture phase — runs before form-level bubble handlers
  );

  async function handleAdd(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    const errorEl = form.querySelector('[data-gd-cart-form-error]');
    const originalBtnText = submitBtn?.textContent;

    if (errorEl) errorEl.textContent = '';
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.classList.remove('is-success', 'is-error');
      submitBtn.classList.add('is-loading');
    }
    // a11y announcement
    const live = document.querySelector('[data-gd-async-live]');
    if (live) live.textContent = 'Adding to cart…';

    try {
      const formData = new FormData(form);
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });

      const body = await r.json().catch(() => ({}));

      if (!r.ok || body.status) {
        const msg = body.description || body.message || 'Could not add this item to your cart.';
        const err = new Error(msg);
        err.response = body;
        throw err;
      }

      // Success — let the drawer refresh itself via its existing listener, then open.
      document.body.dispatchEvent(new CustomEvent('product-added-to-cart', { detail: { form, line: body } }));
      // product-added-to-cart already opens the drawer in gd-cart-drawer.js, but dispatch
      // gd:cart-open too for any other listeners (belt-and-braces).
      document.body.dispatchEvent(new CustomEvent('gd:cart-open'));

      // Joel 2026-04-30: success state — flash the check for ~700ms,
      // then return to default. live-region announces "Added to cart".
      if (submitBtn) {
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-success');
        if (originalBtnText) submitBtn.textContent = originalBtnText;
        setTimeout(() => {
          submitBtn.classList.remove('is-success');
          submitBtn.removeAttribute('aria-busy');
          submitBtn.setAttribute('aria-disabled', 'false');
        }, 700);
      }
      if (live) live.textContent = 'Added to cart';
    } catch (err) {
      console.warn('[gd-cart-add]', err);
      if (live) live.textContent = 'Failed to add to cart';
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
      if (submitBtn) {
        // Error state — × icon for ~2s, then default. Allows a retry
        // tap without a forced page state.
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-error');
        if (originalBtnText) submitBtn.textContent = originalBtnText;
        setTimeout(() => {
          submitBtn.classList.remove('is-error');
          submitBtn.removeAttribute('aria-busy');
          submitBtn.setAttribute('aria-disabled', 'false');
        }, 2000);
      }
    }
  }

  // Expose a minimal API for programmatic use (e.g. custom ATC triggers that can't use a form)
  window.GlamrDipCart = Object.assign(window.GlamrDipCart || {}, {
    add(items) {
      // items: single { id, quantity, properties } or array of those
      const payload = Array.isArray(items) ? { items } : { items: [items] };
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((r) => r.json())
        .then((body) => {
          if (body.status) throw new Error(body.description || 'Cart add failed');
          document.body.dispatchEvent(new CustomEvent('product-added-to-cart', { detail: { line: body } }));
          document.body.dispatchEvent(new CustomEvent('gd:cart-open'));
          return body;
        });
    },
    open() {
      document.body.dispatchEvent(new CustomEvent('gd:cart-open'));
    },
    refresh() {
      document.body.dispatchEvent(new CustomEvent('gd:cart-refresh-request'));
    },
  });
})();
